import React, { useState } from "react";
import { ContentContainer } from "../../../../components/layout";
import { useParams } from "react-router-dom";
import {
  Breadcrumbs,
  Button,
  IconText,
  Modal,
  Select,
  Textarea,
  Textfield,
} from "../../../../components/core";
import ViewVerificationHistoryModal from "../modals/view-verification-history-modal";
import ViewStatusHistoryModal from "../modals/view-status-history-modal";
import ViewPackageHistoryModal from "../modals/view-package-history-modal";
import ChangeStatusModal from "../modals/change-status-modal";
import VerifyIdModal from "../modals/verify-id-modal";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserPackageHistoryInTheLastTenDays,
  getUserStatusHistory,
  handleChangeStatusReducer,
  setUserDataReducer,
} from "../../../../features/locker-user-accounts/user-profile-slice";
import { useMutation, useQuery } from "@apollo/client";
import {
  LOCKER_USER_ACCOUNTS,
  LOCKER_USER_ACCOUNT_PACKAGES,
  SAVE_USER_STATUS_HISTORY,
  UPDATE_USERS,
  UPDATE_USER_STATUS,
  USER_STATUS_HISTORY,
} from "../../../../constants/graphql/locker-user-accounts-queries";
import { API } from "../../../../constants/api";
import axios from "axios";
import { FILTER_PACKAGES } from "../../../../constants/graphql/view-package-history-queries";
import { Dialog } from "primereact/dialog";
import { Editor } from "react-draft-wysiwyg";
import ViewSubmitIdModal from "../modals/view-submit-id-modal";

import SendSMSModal from "../../broadcast-users/components/send-sms-modal";
import SendAppModal from "../../broadcast-users/components/send-app-modal";
import SendEmailModal from "../../broadcast-users/components/send-email-modal";
import { Strings } from "../../../../constants/strings";
import { Card } from "primereact/card";
import { Image } from "primereact/image";
import { Button as PrimereactBUtton } from "primereact/button";
import { Divider } from "primereact/divider";

const currentDateValue = new Date();
const services = ["Dropoff", "Shipout", "Storage"];
const userStatus = ["Suspended", "Active"];
const statusList = [
  "Unverified",
  "Verified",
  "Pending verification",
  "Rejected",
];
const packageStates = {
  110: "Pending",
  121: "Overstay",
  130: "Take Back",
  128: "Claimed",
  138: "Revoked",
  118: "Removed",
  310: "In Locker",
  328: "Claimed",
};
const GENDER = ["Unspecified", "Male", "Female"];
function formatDate(inputDate) {
  const options = { year: "numeric", month: "short", day: "numeric" };
  const date = new Date(inputDate);
  return date.toLocaleDateString("en-US", options);
}
function getISODateTenDaysAgo() {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 10); // Subtract 10 days from the current date
  return currentDate.toISOString().split("T")[0]; // Get the ISO date portion
}
const breadcrumbItems = [
  { label: "Locker User Accounts", path: `/locker-user-accounts/` },
  { label: "User Profile", path: "#" },
];
export default function UserProfilePage() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const idStatusList = useSelector((state) => state.agentProfile.idStatusList);

  const CURRENT_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

  const { userId } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setisLoading] = useState(false);
  const broadCastUsersAPI = new BroadcastUserAPI();
  const userProfileIdAcceptApi = `${process.env.REACT_APP_website_api}${API.user_profile_id_accept}`;
  const userProfileIdRejectApi = `${process.env.REACT_APP_website_api}${API.user_profile_id_reject}`;
  const pinUrl = `${process.env.REACT_APP_website_api}${API.user_customer_service_code_send}`;
  // Redux States
  const changeStatusForm = useSelector(
    (state) => state.userProfile.changeStatusForm
  );
  const userData = useSelector((state) => state.userProfile.userData);
  const packageHistory = useSelector(
    (state) => state.userProfile.packageHistory
  );
  const statusHistory = useSelector((state) => state.userProfile.statusHistory);
  //Local States
  const [
    openViewVerificationHistoryModal,
    setOpenViewVerificationHistoryModal,
  ] = React.useState(false);
  const [openViewStatusHistoryModal, setOpenViewStatusHistoryModal] =
    React.useState(false);
  const [openViewPackageHistoryModal, setOpenViewPackageHistoryModal] =
    React.useState(false);
  const [openChangeStatusModal, setOpenChangeStatusModal] =
    React.useState(false);
  const [openVerifyIdModal, setOpenVerifyIdModal] = React.useState(false);
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [newDate, setNewDate] = React.useState(new Date());
  const [sendEmailData, setSendEmailData] = React.useState({
    message: "",
    subject: "",
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    target: [`${userData.userEmail}`],
    // target: [`${userId}@kenneth.p.galvez@gmail.com`],
  });

  const [sendAppData, setSendAppData] = React.useState({
    message: "",
    target: [`${userData.userMobile}-${userId}`],
    category: "-1",
    image: "",
    subject: "",
  });
  const [openPreMessageAccept, setOpenPreMessageAccept] = React.useState(false);
  const [openPreMessageReject, setOpenPreMessageReject] = React.useState(false);
  const [verifyIdMessage, setVerifyMessage] = React.useState({
    msgToUser: "",
    privateComment: "",
  });
  const [openViewSubmitId, setOpenViewSubmitId] = React.useState(false);
  const [appMessageImage, setAppMessageImage] = React.useState("");
  const [userAccountId, setUserAccountId] = React.useState("");
  // GQL
  const lockerUserAccount = useQuery(LOCKER_USER_ACCOUNTS, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      userId: userId,
    },
    fetchPolicy: "no-cache",
  });
  const lockerUserAccountPackages = useQuery(LOCKER_USER_ACCOUNT_PACKAGES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      userId: userId,
    },
  });
  const userStatusHistory = useQuery(USER_STATUS_HISTORY, {
    variables: {
      userId: userId,
    },
  });
  const [updateUsers] = useMutation(UPDATE_USERS);
  const [saveStatusHistory] = useMutation(SAVE_USER_STATUS_HISTORY);
  const [updateUserStatus] = useMutation(UPDATE_USER_STATUS);

  const operatorId = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).operator_id
    : "";

  const [changesMade, setChangesMade] = useState(false);
  // Handle Changes
  const handleChangeStatus = (event) => {
    const { name, value } = event.target;

    setChangesMade(true);
    dispatch(handleChangeStatusReducer({ name: name, value: value }));
  };
  const handleAcceptUserId = (userStatusComments, verifiedStatusComments) => {
    setOpenVerifyIdModal(false);
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
      title: "Success",
      message: "Successfully accepted a user.",
      open: true,
      actions: (
        <div className="w-full">
          {}
          <Button
            onClick={() => setValidation({ open: false })}
            value={"OK"}
            className={"p-2 w-full"}
          />
        </div>
      ),
    });
    try {
      axios
        .post(userProfileIdAcceptApi, {
          user_id: userId,
          user_mobile: userData.userMobile,
          user_email: userData.userEmail,
        })
        .then((response) => {
          try {
            broadCastUsersAPI
              .sendSms({
                target: [userData.userMobile],
                message: userStatusComments,
                operatorId: localStorage.getItem("user")
                  ? JSON.parse(localStorage.getItem("user")).operator_id
                  : "",
              })
              .then((response) => console.log(response))
              .catch((error) => console.log(error));
            updateUsers({
              variables: {
                users: [
                  {
                    userId: userId,
                    verifiedStatus: 1,
                    verifiedOn: new Date(),
                    idTypeId: userData.idType.idTypeId,
                    idNumber: userData.idNumber,
                    firstName: userData.firstName,
                    comments: "Sample comments",
                  },
                ],
              },
            }).then((data) => {
              lockerUserAccount.refetch({
                operatorId: localStorage.getItem("user")
                  ? JSON.parse(localStorage.getItem("user")).operator_id
                  : "",
                userId: userId,
              });
            });
            saveStatusHistory({
              variables: {
                userStatusHistoryArgs: {
                  userId: userId,
                  verifiedStatus: 1,
                  userStatusComments: userStatusComments,
                  verifiedStatusComments: verifiedStatusComments,
                },
              },
            }).then((data) => {
              userStatusHistory.refetch({
                variables: {
                  userId: userId,
                },
              });
            });
          } catch (error) {
            console.log(error);
          }
        });
    } catch (e) {
      console.log(e);
    }
  };
  const handleRejectUserId = (userStatusComments, verifiedStatusComments) => {
    setOpenVerifyIdModal(false);
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
      title: "Success",
      message: "Successfully rejected a user.",
      open: true,
      actions: (
        <div className="w-full">
          <Button
            onClick={() => setValidation({ open: false })}
            value={"OK"}
            className={"p-2 w-full"}
          />
        </div>
      ),
    });
    try {
      axios
        .post(userProfileIdRejectApi, {
          user_id: userId,
          user_mobile: userData.userMobile,
          user_email: userData.userEmail,
        })
        .then((response) => {
          try {
            console.log(response);
            broadCastUsersAPI
              .sendSms({
                target: [userData.userMobile],
                message: userStatusComments,
                operatorId: localStorage.getItem("user")
                  ? JSON.parse(localStorage.getItem("user")).operator_id
                  : "",
              })
              .then((response) => console.log(response))
              .catch((error) => console.log(error));
            updateUsers({
              variables: {
                users: [
                  {
                    userId: userId,
                    verifiedStatus: 3,
                    idTypeId: userData.idType.idTypeId,
                    idNumber: userData.idNumber,
                    firstName: userData.firstName,
                    comments: "Sample comments",
                  },
                ],
              },
            }).then((data) => {
              lockerUserAccount.refetch({
                operatorId: localStorage.getItem("user")
                  ? JSON.parse(localStorage.getItem("user")).operator_id
                  : "",
                userId: userId,
              });
            });
            saveStatusHistory({
              variables: {
                userStatusHistoryArgs: {
                  userId: userId,
                  verifiedStatus: 3,
                  userStatusComments: userStatusComments,
                  verifiedStatusComments: verifiedStatusComments,
                },
              },
            }).then((data) => {
              userStatusHistory.refetch({
                variables: {
                  userId: userId,
                },
              });
            });
          } catch (error) {
            console.log(error);
          }
        });
    } catch (e) {
      console.log(e);
    }
  };
  const handleSaveChangesStatus = () => {
    setChangesMade(true);
    if (changeStatusForm.status === "-2") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message: "Please select status to proceed.",
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    }

    if (changeStatusForm.message1 === "") {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message: Strings.popup_error_title_empty_field,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else {
      if (changeStatusForm.message2 === "") {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
          title: "Warning",
          message:
            "Private Comments/Reason is empty. While this field is optional, it is recommended to complete it for easier tracking and record-keeping. Would you like to proceed?",
          open: true,
          actions: (
            <div className="grid grid-cols-2 gap-2">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"Go Back"}
                className={"p-2 w-full"}
              />
              <Button
                onClick={editUserStatus}
                value={"Yes"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
      }
    }
  };

  const editUserStatus = () => {
    updateUserStatus({
      variables: {
        user: {
          userId: userId,
          userStatus: changeStatusForm.status,
        },
      },
    }).catch((e) => {
      console.error("Error updating user status:", e);
    });

    saveStatusHistory({
      variables: {
        userStatusHistoryArgs: {
          userId: userId,
          userStatus: changeStatusForm.status,
          userStatusComments: changeStatusForm.message1,
          verifiedStatusComments: changeStatusForm.message2,
        },
      },
    }).catch((e) => {
      console.error("Error saving status history:", e);
    });

    userStatusHistory.refetch({
      variables: {
        userId: userId,
      },
    });

    lockerUserAccount.refetch({
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      userId: userId,
    });

    setOpenChangeStatusModal(false);

    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
      title: "Success",
      message: "Successfully changed user status.",
      open: true,
      actions: (
        <div className="w-full">
          <Button
            onClick={() => {
              setValidation({ open: false });
              window.location.reload(); // Reload the page
            }}
            value={"OK"}
            className={"p-2 w-full"}
          />
        </div>
      ),
    });
  };

  const sendPin = () => {
    axios
      .post(pinUrl, {
        operator_id: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        user_account_id: userAccountId,
        user_mobile: userData.userMobile,
      })
      .then((response) => {
        try {
          console.log(response);
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: "Success",
            message: `PIN successfully sent to user's mobile number. User's new key: ${response.data.d.customer_service_code}`,
            open: true,
            actions: (
              <div className="w-full">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"OK"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        } catch (error) {
          console.log(error);
        }
      });
  };
  // const handleSaveStatusHistory = () => {

  // };
  // USe Effects
  React.useEffect(() => {
    if (lockerUserAccount.data) {
      if (lockerUserAccount.data.lockerUserAccounts.length > 0) {
        let userData = lockerUserAccount.data.lockerUserAccounts[0].user;
        console.log(lockerUserAccount.data.lockerUserAccounts[0].userAccountId);
        setUserAccountId(
          lockerUserAccount.data.lockerUserAccounts[0].userAccountId
        );
        dispatch(setUserDataReducer(userData));
      }
    }
  }, [lockerUserAccount.data]);
  React.useEffect(() => {
    try {
      if (lockerUserAccountPackages.data) {
        let tempArr = [];
        const tenDaysBefore = new Date(getISODateTenDaysAgo());
        const currentDate = new Date();
        if (lockerUserAccountPackages.data.lockerUserAccounts[0].packages) {
          lockerUserAccountPackages.data.lockerUserAccounts[0].packages.forEach(
            (element) => {
              const dateToCheck = new Date(element.packageDate.split("T")[0]);
              if (tenDaysBefore <= dateToCheck && dateToCheck <= currentDate) {
                tempArr.push({
                  lockerName: element.locker.lockerName,
                  lockerLocation: element.lockerLocation,
                  packageDate: formatDate(element.packageDate.split("T")[0]),
                  packageState: packageStates[element.packageStateNo],
                  service:
                    element.packageStateNo >= 100 &&
                    element.packageStateNo < 200
                      ? services[0]
                      : element.packageStateNo >= 200 &&
                        element.packageStateNo < 300
                      ? services[1]
                      : services[2],
                  partnerAgentMobile: element.partnerAgentMobile,
                  pickupByDate: element.pickupByDate,
                  recipientMobile: element.recipientMobile,
                  waybillNumber: element.waybillNumber,
                });
              }
            }
          );
          dispatch(getUserPackageHistoryInTheLastTenDays(tempArr));
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [lockerUserAccountPackages.data]);

  React.useEffect(() => {
    if (userStatusHistory.data) {
      let tempList = [];
      userStatusHistory.data.userStatusHistory.forEach((element) => {
        let tempObj = { ...element };
        console.log({ tempObj });
        // console.log(userStatus[element.userStatus], element.userStatus);
        tempList.push({
          ...tempObj,
          verifiedStatus: statusList[element.verifiedStatus],
          userStatus:
            element.userStatus === "-1"
              ? "Blocked"
              : userStatus[element.userStatus],
          createdAt: formatDate(element.createdAt.split("T")[0]),
        });
      });
      dispatch(getUserStatusHistory(tempList));
    }
  }, [userStatusHistory.data]);

  console.log({ userData, changeStatusForm });
  return userAccountId == "" ? (
    <></>
  ) : (
    <>
      <Breadcrumbs items={breadcrumbItems} />
      <ContentContainer containerTitle={"USER PROFILE"}>
        <div className="px-6">
          <Card className="text-black bg-slate-50">
            <div className="grid grid-cols-6 md:grid-cols-12 space-y-3">
              <>
                {/* user name and stuff */}
                <div className=" col-span-6 md:col-span-12 pb-5">
                  <p className={`text-xl font-bold `}>
                    {userData.firstName} {userData.middleName}{" "}
                    {userData.lastName}
                    {""}
                    {`${userData.suffixName ? ", " + userData.suffixName : ""}`}
                  </p>
                </div>

                <div className="col-span-12 md:col-span-3">
                  {/*  agent picture */}
                  <div className="grid grid-cols-9 px-4 space-y-3">
                    <div className="col-span-9">
                      <Image
                        src={`https://mbox-locker-${CURRENT_ENVIRONMENT}.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id1.jpg?${newDate.getTime()}`}
                        alt="ID Profile"
                        onClick={() => {
                          setOpenViewSubmitId(true);
                        }}
                        className=" object-cover cursor-pointer"
                        // preview
                        imageClassName="w-[320px] h-[320px] object-fill outline outline-6 shadow-lg outline-stone-600"
                      />
                    </div>

                    <div className="col-span-9">
                      {userData.verifiedStatus === 2 ? (
                        <PrimereactBUtton
                          label={"Click to Verify IDs"}
                          className={
                            "bg-primary-primaryYellow uppercase tracking-normal rounded-md w-full h-12 mx-auto"
                          }
                          onClick={() => setOpenVerifyIdModal(true)}
                          disabled={
                            accessPermission.agents === 1 ||
                            accessPermission.agents === "1"
                          }
                        />
                      ) : (
                        <p className="font-semibold text-center italic">
                          {idStatusList[userData.verifiedStatus]}{" "}
                          {userData.verifiedStatus === 1 &&
                            userData.verifiedOn &&
                            `on ${formatDate(
                              userData.verifiedOn.split("T")[0]
                            )}`}
                        </p>
                      )}
                    </div>

                    <div className="col-span-9 mx-auto">
                      <IconText
                        className={"underline"}
                        text="Verification History"
                        iconUrl={`${process.env.PUBLIC_URL}/assets/images/history_icon.png`}
                        onClick={() =>
                          setOpenViewVerificationHistoryModal(true)
                        }
                      />
                    </div>

                    <div className="col-span-9">
                      <div className="grid grid-cols-2 space-x-2">
                        <PrimereactBUtton
                          label={"Send Email"}
                          className={
                            "border col-span-1 uppercase border-primary-primaryYellow rounded-md h-12 mx-auto px-2 w-full hover:bg-gray-200"
                          }
                          disabled={
                            accessPermission.lockerUserAccounts === 1 ||
                            accessPermission.lockerUserAccounts === "1"
                          }
                          onClick={() => {
                            if (
                              userData.userEmail === "" ||
                              userData.userEmail === null ||
                              userData.userEmail === undefined
                            ) {
                              setValidation({
                                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                                title: "Error",
                                message:
                                  "The user’s email is empty. As a result, we may not be able to send them any communications.",
                                open: true,
                                actions: (
                                  <div className="w-full">
                                    <Button
                                      onClick={() =>
                                        setValidation({ open: false })
                                      }
                                      value={"OK"}
                                      className={"p-2 w-full"}
                                    />
                                  </div>
                                ),
                              });
                            } else {
                              setSendEmailData((prev) => ({
                                ...prev,
                                open: true,
                              }));
                            }
                          }}
                        />
                        <PrimereactBUtton
                          label={"Send App Message"}
                          className={
                            "border col-span-1 uppercase border-primary-primaryYellow rounded-md h-12 mx-auto px-2 w-full hover:bg-gray-200"
                          }
                          disabled={
                            accessPermission.lockerUserAccounts === 1 ||
                            accessPermission.lockerUserAccounts === "1"
                          }
                          onClick={() => {
                            setSendAppData((prev) => ({
                              ...prev,
                              open: true,
                            }));
                          }}
                        />

                        <PrimereactBUtton
                          label={"Send PIN to Authenticate User's Mobile"}
                          className={
                            "border col-span-2 mt-2 uppercase border-primary-primaryYellow rounded-md h-12 hover:bg-gray-200"
                          }
                          disabled={
                            accessPermission.lockerUserAccounts === 1 ||
                            accessPermission.lockerUserAccounts === "1"
                          }
                          onClick={sendPin}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-span-12 md:col-span-4 p-3">
                  <div className="grid grid-cols-6 space-y-7  items-center">
                    <div className="col-span-6">
                      <div className="grid grid-cols-6">
                        <div className="col-span-2 ">User Mobile: </div>
                        <div className="font-bold col-span-4 ">
                          +{userData.userMobile}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-6">
                      <div className="grid grid-cols-6">
                        <div className="col-span-2">Email Address: </div>
                        <div className="font-bold col-span-4 ">
                          {userData.userEmail ? userData.userEmail : "N/A"}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-6">
                      <div className="grid grid-cols-6">
                        <div className="col-span-2">Birthdate: </div>
                        <div className="font-bold col-span-4 ">
                          {userData.birthDate
                            ? formatDate(userData.birthDate)
                            : "N/A"}{" "}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-6">
                      <div className="grid grid-cols-6">
                        <div className="col-span-2">Gender: </div>
                        <div className="font-bold col-span-4 ">
                          {GENDER[userData.gender]}
                        </div>
                      </div>
                    </div>

                    <div className="col-span-6">
                      <Divider className="border border-gray-200"></Divider>
                    </div>

                    <div className="col-span-6">
                      <div className="grid grid-cols-6">
                        <div className="col-span-2">Registration Date: </div>
                        <div className="font-bold col-span-4 ">
                          {userData.createdAt
                            ? formatDate(
                                new Date(userData.createdAt.split("T"[0]))
                              )
                            : "N/A"}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-span-12 md:col-span-4">
                  <div className="grid grid-cols-12 md:grid-cols-6 space-y-7 items-center">
                    <div className="col-span-12 md:col-span-6 space-y-2">
                      <div className="grid grid-cols-12 md:grid-cols-8 items-center">
                        <div className="col-span-5 md:col-span-2 ">
                          User Status:
                        </div>
                        <div className="font-bold col-span-7 md:col-span-2">
                          {userData.userStatus === "-1" ||
                          userData.userStatus === -1
                            ? "Blocked"
                            : userStatus[userData.userStatus]}
                          <i
                            className={`fas fa-edit cursor-pointer ml-2 mt-1 ${
                              accessPermission.lockerUserAccounts === 1 ||
                              accessPermission.lockerUserAccounts === "1"
                                ? "hidden"
                                : ""
                            }`}
                            onClick={() => setOpenChangeStatusModal(true)}
                          ></i>
                        </div>
                        <div className="col-span-12 pt-2 md:pt-0 italic md:col-span-4">
                          <IconText
                            className={"underline"}
                            text="View Status history"
                            iconUrl={`${process.env.PUBLIC_URL}/assets/images/history_icon.png`}
                            onClick={() => setOpenViewStatusHistoryModal(true)}
                          />
                        </div>
                      </div>
                      {/* <div className="grid grid-cols-12 items-center">
															<div className="col-span-4"></div> */}

                      {/* </div> */}
                    </div>

                    <div className="col-span-12 md:col-span-6 italic">
                      <div>
                        <IconText
                          className={"underline"}
                          text="View Package History"
                          iconUrl={`${process.env.PUBLIC_URL}/assets/images/history_icon.png`}
                          onClick={() => setOpenViewPackageHistoryModal(true)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div>
          </Card>
        </div>
        <ViewPackageHistoryModal
          open={openViewPackageHistoryModal}
          onClose={() => setOpenViewPackageHistoryModal(false)}
          data={packageHistory}
        />
        <ViewVerificationHistoryModal
          data={statusHistory.filter((x) => x.verifiedStatus !== undefined)}
          open={openViewVerificationHistoryModal}
          onClose={() => setOpenViewVerificationHistoryModal(false)}
        />
        <ViewStatusHistoryModal
          data={statusHistory.filter((x) => x.userStatus !== undefined)}
          open={openViewStatusHistoryModal}
          onClose={() => setOpenViewStatusHistoryModal(false)}
        />
        <ChangeStatusModal
          open={openChangeStatusModal}
          userData={userData}
          onClose={() => setOpenChangeStatusModal(false)}
          handleChangeStatus={handleChangeStatus}
          values={changeStatusForm}
          onSaveStatus={handleSaveChangesStatus}
          changesMade={changesMade}
          setChangesMade={setChangesMade}
        />
        <VerifyIdModal
          data={userData}
          open={openVerifyIdModal}
          onClose={() => setOpenVerifyIdModal(false)}
          setVerifyMessage={setVerifyMessage}
          userAccountId={userAccountId}
          onVerifyUser={(userStatusComments, verifyStatusComments) => {
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
              title: "Accept User",
              message: "Are you sure you want to accept this user?",
              open: true,
              actions: (
                <div className="w-full grid grid-cols-2 gap-2">
                  <Button
                    onClick={() => setValidation({ open: false })}
                    value={"No"}
                    className={"p-2"}
                  />
                  <Button
                    onClick={() => {
                      setOpenPreMessageAccept(true);
                      setVerifyMessage((prev) => ({
                        ...prev,
                        msgToUser: userStatusComments,
                      }));
                      setVerifyMessage((prev) => ({
                        ...prev,
                        privateComment: verifyStatusComments,
                      }));
                      setValidation({ open: false });
                    }}
                    value={"Yes"}
                    className={"p-2"}
                  />
                </div>
              ),
            });
          }}
          onRejectUser={(userStatusComments, verifyStatusComments) => {
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: "Reject User",
              message: "Are you sure you want to reject this user?",
              open: true,
              actions: (
                <div className="w-full grid grid-cols-2 gap-2">
                  <Button
                    onClick={() => setValidation({ open: false })}
                    value={"No"}
                    className={"p-2"}
                  />
                  <Button
                    onClick={() => {
                      setOpenPreMessageReject(true);
                      setVerifyMessage((prev) => ({
                        ...prev,
                        msgToUser: userStatusComments,
                      }));
                      setVerifyMessage((prev) => ({
                        ...prev,
                        privateComment: verifyStatusComments,
                      }));
                      setValidation({ open: false });
                      // handleRejectUserId(
                      // 	userStatusComments,
                      // 	verifyStatusComments
                      // )
                    }}
                    value={"Yes"}
                    className={"p-2"}
                  />
                </div>
              ),
            });
          }}
        />
        <Dialog
          onHide={() => {
            setOpenPreMessageReject(false);
          }}
          visible={openPreMessageReject}
        >
          <p className="font-bold text-lg text-center">
            User {userData.firstName} {userData.lastName} will receive this SMS
          </p>
          <hr className="my-6"></hr>
          <p className="mb-4">
            Sorry. Your MBOX User ID submission has been rejected.
          </p>
          <p>{verifyIdMessage.msgToUser}</p>
          <hr className="my-6"></hr>
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setOpenPreMessageReject(false)}
              value={"CANCEL"}
              className={"p-2"}
            />
            <Button
              onClick={(event) => {
                handleRejectUserId(
                  verifyIdMessage.msgToUser,
                  verifyIdMessage.privateComment
                );
                setOpenPreMessageReject(false);
                setVerifyMessage({
                  msgToUser: "",
                  privateComment: "",
                });
              }}
              value={"PROCEED"}
              className={"p-2"}
              name="accept"
            />
          </div>
        </Dialog>
        <Dialog
          onHide={() => {
            setOpenPreMessageAccept(false);
          }}
          visible={openPreMessageAccept}
        >
          <p className="font-bold text-lg text-center">
            User {userData.firstName} {userData.lastName} will receive this SMS
          </p>
          <hr className="my-6"></hr>
          <p className="mb-4">
            Congratulations! Your ID has been verified. You may now use the
            Storage function and other features of MBOX.
          </p>
          <p>{verifyIdMessage.msgToUser}</p>
          <hr className="my-6"></hr>
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setOpenPreMessageAccept(false)}
              value={"CANCEL"}
              className={"p-2"}
            />
            <Button
              onClick={(event) => {
                handleAcceptUserId(
                  verifyIdMessage.msgToUser,
                  verifyIdMessage.privateComment
                );
                setOpenPreMessageAccept(false);
                setVerifyMessage({
                  msgToUser: "",
                  privateComment: "",
                });
              }}
              value={"Confirm"}
              className={"p-2"}
              name="accept"
            />
          </div>
        </Dialog>
        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
        {
          // New Modals
        }
        <SendAppModal
          header={`App Message Notification`}
          open={sendAppData.open}
          data={sendAppData}
          onChange={(e) => {
            const { name, value } = e.target;
            setSendAppData((prev) => ({ ...prev, [name]: value }));
          }}
          onSubmit={() => {
            broadCastUsersAPI
              .appMessage({
                operatorId: operatorId,
                message: sendAppData.message,
                target: sendAppData.target,
                category: sendAppData.category,
                image: sendAppData.image,
                subject: sendAppData.subject,
              })
              .then((r) => {
                console.log(r);
                setisLoading(false);
                setSendAppData({
                  open: false,
                  operatorId: operatorId,
                  message: "",
                  target: sendAppData.target,
                  category: -1,
                  image: "",
                  subject: "",
                });
                // setValidation({
                // 	icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                // 	title: "Invalid data",
                // 	message: "",
                // 	open: false,
                // })
              });
          }}
          onClose={() => {
            setSendAppData({
              open: false,
              operatorId: operatorId,
              message: "",
              target: sendAppData.target,
              category: -1,
              image: "",
              subject: "",
            });
          }}
        />
        <SendEmailModal
          header={`Email Message Notification`}
          open={sendEmailData.open}
          data={sendEmailData}
          onChange={(e) => {
            const { name, value } = e.target;
            setSendEmailData((prev) => ({ ...prev, [name]: value }));
          }}
          onSubmit={() => {
            broadCastUsersAPI
              .sendEmail({
                message: sendEmailData.message,
                subject: sendEmailData.subject,
                operatorId: operatorId,
                target: sendEmailData.target,
              })
              .then((e) => {
                setSendEmailData({
                  open: false,
                  operatorId: operatorId,
                  message: "",
                  target: sendEmailData.target,
                  subject: "",
                });
                // setValidation({
                // 	icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                // 	title: "Invalid data",
                // 	message: "",
                // 	open: false,
                // })
              });
          }}
          onClose={() => {
            setSendEmailData({
              open: false,
              operatorId: operatorId,
              message: "",
              target: sendEmailData.target,
              subject: "",
            });
          }}
        />

        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
        <ViewSubmitIdModal
          open={openViewSubmitId}
          images={[
            {
              itemImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id1.jpg?${newDate.getTime()}`,
              thumbnailImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id1.jpg?${newDate.getTime()}`,
              alt: "Description for Image 1",
              title: "Title 1",
            },
            {
              itemImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id2.jpg?${newDate.getTime()}`,
              thumbnailImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id2.jpg?${newDate.getTime()}`,
              alt: "Description for Image 2",
              title: "Title 2",
            },
            {
              itemImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id3.jpg?${newDate.getTime()}`,
              thumbnailImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id3.jpg?${newDate.getTime()}`,
              alt: "Description for Image 3",
              title: "Title 3",
            },
            {
              itemImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id4.jpg?${newDate.getTime()}`,
              thumbnailImageSrc: `https://mbox-locker-live.s3.ap-southeast-1.amazonaws.com/image/user/profile/id/${userAccountId}/id4.jpg?${newDate.getTime()}`,
              alt: "Description for Image 4",
              title: "Title 4",
            },
          ]}
          onClose={() => {
            setOpenViewSubmitId(false);
          }}
        />
      </ContentContainer>
    </>
  );
}

class BroadcastUserAPI {
  async sendSms({ target, message, operatorId }) {
    return axios
      .post(`${process.env.REACT_APP_API_URL_SEND_SMS}`, {
        operator_id: operatorId,
        sms_message: message,
        sms_contacts: target,
      })
      .then((response) => {
        return response.status;
      })
      .catch((error) => {
        return error;
      });
  }
  async appMessage(appData) {
    return axios
      .post(`${process.env.REACT_APP_API_URL_SEND_APP}`, {
        users: {},
        user_mobile: [],
        user_email: [],
        email_subject: "",
        email_message: "",
        user_id: appData.target,
        user_message_type_no: appData.category,
        app_message: appData.message,
        app_image: appData.image,
      })
      .then((response) => {
        return response.status;
      })
      .catch((error) => {
        return error;
      });
  }

  async sendEmail(emailData) {
    return axios
      .post(`${process.env.REACT_APP_API_URL_SEND_EMAIL}`, {
        operator_id: emailData.operatorId,
        email_subject: emailData.subject,
        email_message: emailData.message,
        email_contacts: emailData.target,
      })
      .then((response) => {
        return response.status;
      })
      .catch((error) => {
        return error;
      });
  }
}
